module.exports = __webpack_public_path__ + "img/banner_2.3d35e027.jpg";